import React from "react";
import { styles } from "./leadsStyles";

export function LeadsListTab({ vm }) {
  const {
    loading,
    processPendingConversations,
    deleteMessage,
    deleteStatus,
    leads,
    error,
    selectedLeads,
    handleDeleteLeads,
    handleLeadSelection,
    toggleLeadExpansion,
    expandedLead,
    formatDate,
    botNameById,
  } = vm;
  return (
              <div>
                {/* Botão para processar conversas pendentes */}
                <div style={{ marginBottom: '20px' }}>
                  <button
                    onClick={processPendingConversations}
                    disabled={loading}
                    style={styles.buttonPrimary}
                  >
                    {loading ? 'Processando…' : 'Processar Conversas Pendentes'}
                  </button>
                </div>
                {/* Mensagem de exclusão */}
                {deleteMessage && (
                  <div style={{
                    ...styles.message,
                    ...(deleteStatus === "success" ? styles.messageSuccess : styles.messageError)
                  }}>
                    {deleteMessage}
                  </div>
                )}

                {/* Botão de exclusão */}
                {leads.length > 0 && (
                  <div style={{ marginBottom: '20px' }}>
                    <button
                      onClick={handleDeleteLeads}
                      disabled={selectedLeads.length === 0}
                      style={{
                        ...styles.buttonDanger,
                        opacity: selectedLeads.length === 0 ? 0.5 : 1,
                        cursor: selectedLeads.length === 0 ? "not-allowed" : "pointer",
                      }}
                    >
                      Excluir {selectedLeads.length > 0 ? `(${selectedLeads.length})` : ''} Leads Selecionados
                    </button>
                  </div>
                )}
            
                {loading ? (
                <p style={styles.loadingText}>Carregando leads...</p>
                ) : error ? (
                <p style={styles.errorText}>{error}</p>
                ) : leads.length === 0 ? (
                <p style={styles.emptyText}>Nenhum lead encontrado para este cliente.</p>
                ) : (
                <div>
                    <p style={styles.leadCount}>
                    Sua empresa tem <strong>{leads.length}</strong> leads cadastrados.
                    </p>
                    <div style={styles.leadList}>
                    {leads.map((lead) => (
                        <div key={lead._id} style={styles.leadItem}>
                        <div style={styles.leadHeader}>
                            <input
                            type="checkbox"
                            checked={selectedLeads.includes(lead._id)}
                            onChange={() => handleLeadSelection(lead._id)}
                            onClick={(e) => e.stopPropagation()}
                            style={{ marginRight: '10px' }}
                            />
                            <div 
                            style={{ 
                                display: 'flex', 
                                justifyContent: 'space-between', 
                                alignItems: 'center',
                                flex: 1,
                                cursor: 'pointer'
                            }}
                            onClick={() => toggleLeadExpansion(lead._id)}
                            >
                            <span style={styles.leadName}>
                                {lead.name||"Nome não informado"}
                            </span>
                            <span style={styles.leadDate}>
                                {formatDate(lead.createdAt)}
                            </span>
                            <span style={styles.expandIcon}>
                                {expandedLead === lead._id ? "▼" : "▶"}
                            </span>
                            </div>
                        </div>
                        
                        {expandedLead === lead._id && (
                            <div style={styles.leadDetails}>
                            <div style={styles.detailRow}>
                                <span style={styles.detailLabel}>Bot de origem:</span>
                                <span style={styles.detailValue}>
                                  {lead.botId ? (botNameById[lead.botId] || lead.botId) : "Não informado"}
                                </span>
                            </div>
                            <div style={styles.detailRow}>
                                <span style={styles.detailLabel}>Email:</span>
                                <span style={styles.detailValue}>{lead.email||"Não informado"}</span>
                            </div>
                            <div style={styles.detailRow}>
                                <span style={styles.detailLabel}>Telefone:</span>
                                <span style={styles.detailValue}>{lead.phone||"Não informado"}</span>
                            </div>
                            <div style={styles.detailRow}>
                                <span style={styles.detailLabel}>Nível de Interesse:</span>
                                <span style={styles.detailValue}>
                                <span style={{
                                    ...styles.interestBadge,
                                    ...(lead.interestLevel === 'alto' ? styles.badgeHigh :
                                        lead.interestLevel === 'médio' ? styles.badgeMedium : styles.badgeLow)
                                }}>
                                    {lead.interestLevel||"não definido"}
                                </span>
                                </span>
                            </div>
                            <div style={styles.detailRow}>
                                <span style={styles.detailLabel}>Produto/Serviço:</span>
                                <span style={styles.detailValue}>{lead.product||"Não especificado"}</span>
                            </div>
                            <div style={styles.detailRow}>
                                <span style={styles.detailLabel}>Objeções/Dúvidas:</span>
                                <span style={styles.detailValue}>{lead.objections||"Nenhuma registrada"}</span>
                            </div>
                            <div style={styles.detailRow}>
                                <span style={styles.detailLabel}>Urgência:</span>
                                <span style={styles.detailValue}>
                                <span style={{
                                    ...styles.urgencyBadge,
                                    ...(lead.urgency === 'alta' ? styles.badgeHigh :
                                        lead.urgency === 'média' ? styles.badgeMedium : styles.badgeLow)
                                }}>
                                    {lead.urgency||"não definida"}
                                </span>
                                </span>
                            </div>
                            <div style={styles.detailRow}>
                                <span style={styles.detailLabel}>Resumo:</span>
                                <span style={styles.detailValue}>{lead.summary||"Sem resumo disponível"}</span>
                            </div>
                            <div style={styles.detailRow}>
                                <span style={styles.detailLabel}>Status de Envio:</span>
                                <span style={styles.detailValue}>
                                {lead.isProcessed ? (
                                    <span style={styles.statusSent}>Enviado para CRM ✓</span>
                                ) : (
                                    <span style={styles.statusPending}>Pendente de envio</span>
                                )}
                                </span>
                            </div>
                            </div>
                        )}
                        </div>
                    ))}
                    </div>
                </div>
                )}
              </div>
  );
}
